<template>
  <div class="outSideList">
    <div class="filters">
      <el-form :inline="true">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" :title="$t('lang.lab_selete')">
            <!-- 区域名称 -->
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_locationArea')" v-model="locationArea">
              </el-input>
            </el-form-item>
            <!-- 项目名称 -->
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_projectName')" v-model="projectName">
              </el-input>
            </el-form-item>
            <!-- 管理业态 -->
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_managementFormat')"
                v-model="managementFormat">
              </el-input>
            </el-form-item>
            <!-- 服务类型 -->
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_serviceType')" v-model="serviceType">
              </el-input>
            </el-form-item>
            <!-- 代办机构 -->
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_agentMechanism')"
                v-model="agentMechanism">
              </el-input>
            </el-form-item>
            <br>
            <!-- 中标单位 -->
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_winUnit')" v-model="winUnit">
              </el-input>
            </el-form-item>
            
            <!-- 招标日期 -->
            <el-form-item :label="$t('lang.lab_biddingDate')" class="key-data1">
              <el-date-picker v-model="biddingDate" :format="$t('lang.lab_DATA')" value-format="timestamp" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <!-- 服务期限 -->
            <el-form-item :label="$t('lang.lab_dateFw')" class="key-data">
              <el-date-picker v-model="dateFw" :format="$t('lang.lab_DATA')" value-format="timestamp" type="daterange"
                :range-separator="$t('lang.lab_to')" :start-placeholder="$t('lang.lab_startDate')"
                :end-placeholder="$t('lang.lab_endDate')">
              </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="getTablelist()">{{$t('lang.btn_search')}}</el-button>
            <!-- <br> -->
            <!-- 招标状态 -->
            <!-- <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_outSideZbzt')" v-model="outSideZbzt">
              </el-input>
            </el-form-item> -->
            <!-- <br> -->

          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <!-- 列表 -->
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="add()">{{$t('lang.lab_newOutSide')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData" class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column :label="$t('lang.lab_locationArea')" width="210px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.locationArea&&scope.row.locationArea.length> require('@/config/enum').tableDatamaxlength12"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.locationArea }}
                </span>
              </div>
              <div>
                {{ scope.row.locationArea.substring(0, require('@/config/enum').tableDatamaxlength12) | valueIsNull }}
                <span v-if="scope.row.locationArea.length>require('@/config/enum').tableDatamaxlength12">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.locationArea | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_projectName')" width="210px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.projectName&&scope.row.projectName.length> require('@/config/enum').tableDatamaxlength12"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.projectName }}
                </span>
              </div>
              <div>
                {{ scope.row.projectName.substring(0, require('@/config/enum').tableDatamaxlength12) | valueIsNull }}
                <span v-if="scope.row.projectName.length>require('@/config/enum').tableDatamaxlength12">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.projectName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_managementFormat')" width="150px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.managementFormat&&scope.row.managementFormat.length> require('@/config/enum').tableDatamaxlength9"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.managementFormat }}
                </span>
              </div>
              <div>
                {{ scope.row.managementFormat.substring(0, require('@/config/enum').tableDatamaxlength9) | valueIsNull }}
                <span v-if="scope.row.managementFormat.length>require('@/config/enum').tableDatamaxlength9">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.managementFormat | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="serviceType" :label="$t('lang.lab_serviceType')" width="150px">
        </el-table-column>
        <el-table-column prop="biddingDate" :label="$t('lang.lab_biddingDate')" width="130px">
          <template slot-scope="scope">{{ scope.row.biddingDate | timeYMD }}</template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_agentMechanism')" width="175px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.agentMechanism&&scope.row.agentMechanism.length> require('@/config/enum').tableDatamaxlength9"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.agentMechanism }}
                </span>
              </div>
              <div>
                {{ scope.row.agentMechanism.substring(0, require('@/config/enum').tableDatamaxlength9) | valueIsNull }}
                <span v-if="scope.row.agentMechanism.length>require('@/config/enum').tableDatamaxlength9">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.agentMechanism | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="biddingAmount" :label="$t('lang.lab_biddingAmount')" width="130px"></el-table-column>
        <el-table-column prop="serviceStartTime" :label="$t('lang.lab_dateFwStart')" width="130px">
          <template slot-scope="scope">{{ scope.row.serviceStartTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column prop="serviceEndTime" :label="$t('lang.lab_dateFwEnd')" width="130px">
          <template slot-scope="scope">{{ scope.row.serviceEndTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column prop="state" :label="$t('lang.lab_outSideZbzt')" width="120px">
          <template slot-scope="scope">
            <span class="red" v-if="scope.row.state == '即将招标'">即将招标</span>
            <span v-if="scope.row.state == '准备期'">准备期</span>
            <span v-if="scope.row.state == '正常'">正常</span>
            <span v-if="scope.row.state == '已过期'">已过期</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_winUnit')" width="175px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.winUnit&&scope.row.winUnit.length> require('@/config/enum').tableDatamaxlength9"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.winUnit }}
                </span>
              </div>
              <div>
                {{ scope.row.winUnit.substring(0, require('@/config/enum').tableDatamaxlength9) | valueIsNull }}
                <span v-if="scope.row.winUnit.length>require('@/config/enum').tableDatamaxlength9">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.winUnit | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="winPrice" :label="$t('lang.lab_winPrice')" width="130px"></el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" align="center"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="red" @click="deleted(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
            <el-button @click="callPerson(scope.row.id,0)" v-if="scope.row.remindState == '0'">{{$t('lang.lab_callMe')}}
            </el-button>
            <el-button @click="callPerson(scope.row.id,1)" v-if="scope.row.remindState == '1'">
              {{$t('lang.lab_callMeReady')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 提醒弹窗 -->
    <el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="600px" :title="changeTitle"
      @closed="handleDialogClosed">
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lbl_duties_mobile')" prop="txMobile">
          <el-input v-model="form.txMobile" :placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_duties_mobile')"
            :disabled="callInputDis"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_callMeTime')" prop="txDate">
          <div class="block">
            <el-date-picker :picker-options="pickerOptions" :disabled="callInputDis" v-model="form.txDate" type="date"
              value-format="timestamp" :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_callMeTime')"
              class="input"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_callContent')" prop="txNote">
          <el-input v-model="form.txNote" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callContent')"
            :disabled="callInputDis" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel" v-if="!callInputDis">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="addRemind('form')" v-if="!callInputDis">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:outSideList
   *@Description:外拓信息列表
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2021-03-30
   */
  export default {
    name: '/manage/main.outSide',
    data() {
      var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
      var isPhone = (rule, value, callback) => {
        if (value === '') {
          callback(
            new Error(
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lbl_duties_mobile')
            )
          )
        } else if (!phone.test(value)) {
          callback(
            new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
          )
        } else {
          callback()
        }
      }
      return {
        newDate:Date.parse(new Date()),
        airString: '', //空字符串
        biddingDate: '', //招标日期
        dateFw: '', //服务期限
        locationArea: '', //区域名称
        projectName: '', //项目名称
        managementFormat: '', //管理业态
        serviceType: '', //服务类型
        agentMechanism: '', //代办机构
        biddingAmount: '', //招标总价
        outSideZbzt: '', //招标状态
        winUnit: '', //中标单位
        winPrice: '', //中标价格
        pageCount: 0, // 总页数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        activeNames: ['1'], // 展开关闭
        tableData: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now()
          }
        }, //只能选之后的日期
        show: false, // 提醒的弹框
        changeTitle: '', // 弹框的title
        callInputDis: false, // 提醒时，是否为已提醒
        form: {
          txMobile: '', // 弹框电话
          txNote: '', // 弹框内容
          txDate: '', // 弹框日期
          remindId: '' // 此条数据的id
        },
        rules: {
          txMobile: [{
            required: true,
            validator: isPhone,
            trigger: 'blur'
          }],
          txNote: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_callContent'),
            trigger: 'blur'
          }],
          txDate: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_callMeTime'),
            trigger: 'blur'
          }]
        },
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('outSideForm', '')
      }, 200)
      this.getTablelist()
    },
    activated() {
      this.getTablelist()
    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      // 招标状态
      getDateDiff(dateTimeStamp) {
        var result;
        var minute = 1000 * 60;
        var hour = minute * 60;
        var day = hour * 24;
        var month = day * 30;
        var now = new Date().getTime();
        var diffValue = dateTimeStamp - now;
        if (diffValue < 0) {
          return '已过期';
        }
        var monthC = diffValue / month;
        if (monthC <= 3 && monthC > 1) {
          result = '准备期'
        } else if (monthC <= 1 && monthC > 0) {
          result = '即将招标'
        } else if (monthC > 3) {
          result = '正常'
        }
        return result;
      },
      // 外拓信息列表
      getTablelist() {
        let loading = this.$loading()
        let url
        console.log(this.dateFw)
        if (this.dateFw) {
          if (this.biddingDate) {
            url =
              `/biddingInformation?pageNo=${this.pageNo}&pageSize=${this.pageSize}&locationArea=${this.locationArea}&projectName=${this.projectName}&managementFormat=${this.managementFormat}&serviceType=${this.serviceType}&biddingDateX=${this.biddingDate}&agentMechanism=${this.agentMechanism}&winUnit=${this.winUnit}&winPrice=${this.winPrice}&serviceStartTimeX=${this.dateFw[0]}&serviceEndTimeX=${this.dateFw[1]}`
          } else {
            url =
              `/biddingInformation?pageNo=${this.pageNo}&pageSize=${this.pageSize}&locationArea=${this.locationArea}&projectName=${this.projectName}&managementFormat=${this.managementFormat}&serviceType=${this.serviceType}&biddingDateX=${this.airString}&agentMechanism=${this.agentMechanism}&winUnit=${this.winUnit}&winPrice=${this.winPrice}&serviceStartTimeX=${this.dateFw[0]}&serviceEndTimeX=${this.dateFw[1]}`
          }

        } else {
          if (this.biddingDate) {
            url =
              `/biddingInformation?pageNo=${this.pageNo}&pageSize=${this.pageSize}&locationArea=${this.locationArea}&projectName=${this.projectName}&managementFormat=${this.managementFormat}&serviceType=${this.serviceType}&biddingDateX=${this.biddingDate}&agentMechanism=${this.agentMechanism}&winUnit=${this.winUnit}&winPrice=${this.winPrice}&serviceStartTimeX=${this.airString}&serviceEndTimeX=${this.airString}`
          } else {
            url =
              `/biddingInformation?pageNo=${this.pageNo}&pageSize=${this.pageSize}&locationArea=${this.locationArea}&projectName=${this.projectName}&managementFormat=${this.managementFormat}&serviceType=${this.serviceType}&biddingDateX=${this.airString}&agentMechanism=${this.agentMechanism}&winUnit=${this.winUnit}&winPrice=${this.winPrice}&serviceStartTimeX=${this.airString}&serviceEndTimeX=${this.airString}`
          }
        }

        this.$get(url).then(res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
              for (let i = 0; i < this.tableData.length; i++) {
                var outSideState = this.getDateDiff(this.tableData[i].biddingDate)
                this.$set(this.tableData[i], 'state', outSideState)
                // 提醒过后，重置提醒状态
                if(this.tableData[i].txDate<this.newDate){
                  this.$set(this.tableData[i], 'remindState', 0)
                }
              }
              console.log(this.tableData)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增
      add() {
        window.localStorage.setItem('outSideForm', '')
        this.$router.push({
          name: 'outSideEdit'
        })
      },
      // 修改
      edit(id) {
        window.localStorage.setItem('outSideForm', '')
        this.$router.push({
          name: 'outSideEdit',
          query: {
            id: id
          }
        })
      },
      // 删除
      deleted(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            this.$delete(`/biddingInformation/${id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getTablelist()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 弹框监听关闭
      handleDialogClosed() {
        this.form.txNote = ''
        this.form.txDate = ''
        this.form.txMobile = ''
        this.$refs.form.clearValidate()
      },
      // 提醒
      callPerson(id, state) {
        this.changeTitle = this.$i18n.t('lang.lab_putRedmin')
        this.form.remindId = id
        this.form.txNote = ''
        this.form.txDate = ''
        this.form.txMobile = ''
        if (state == 0) {
          this.callInputDis = false
        }
        if (state == 1) {
          let loading = this.$loading()
          this.$get(`/biddingInformation/${id}`).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.form.txNote = res.biddingInformation.txNote
                this.form.txDate = res.biddingInformation.txDate
                this.form.txMobile = res.biddingInformation.txMobile
                this.callInputDis = true
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
        this.show = true
      },
      // 提醒弹框保存
      addRemind(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
              biddingInformationId: this.form.remindId,
              txMobile: this.form.txMobile,
              txNote: this.form.txNote,
              txDate: this.form.txDate
            }
            let loading = this.$loading()
            this.$post(`/biddingInformationRemind`, params).then(
              res => {
                loading.close()
                console.log(res)
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.getTablelist()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // 提醒弹框清空
      rest(form) {
        this.form.txMobile = ''
        this.form.txDate = ''
        this.form.txNote = ''
      },
    }
  }
</script>

<style lang="scss">
  .outSideList {
    .detp-type {
      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 315px;

          .el-input__inner {
            min-width: 60px;
          }
        }
      }
    }

    .el-collapse-item__header {
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom: 0px;
    }

    .el-collapse {
      border-top: 0px;
    }

    .el-collapse-item__wrap {
      will-change: height;
      background-color: #FFF;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #EBEEF5;
    }

    .key-input {
      width: 17%;

      .el-form-item__content {
        width: 100%;

        .el-input__inner {
          min-width: 60px;
        }
      }
    }

    .key-data {
      width: 30%;

      .el-form-item__content {
        width: 80%;

        .el-range-editor {
          width: 100%;
        }

        .el-input__inner {
          width: 100%;
        }
      }
    }

    .key-data1 {
      width: 27%;

      .el-form-item__content {
        width: 80%;

        .el-date-editor {
          width: 100%;
        }

        .el-input__inner {
          width: 100%;
        }
      }
    }

    .selee {
      width: 28%;

      .el-form-item__content {
        width: 100%;
        min-width: 180px;

        .el-select {
          width: 100%;
          min-width: 180px;

          .el-input--suffix {
            min-width: 180px;
          }
        }
      }
    }

    .key-dept {
      width: 50%;

      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 100%;
        }
      }

    }

    .red {
      color: red;
    }

    .filters .el-date-editor .el-input {
      width: 100%;
    }

    .mt20 {
      margin-top: 20px;
    }
  }
</style>